module.exports = require("/home/runner/work/website/website/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 332
// module chunks = 231608221292675